export const REQUEST_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW = 3

export const REQUEST_PROFILE_HEADER_INFO_ITEMS_MIN_ITEMS_IN_ROW = 2

export const REQUEST_PROFILE_HEADER_INFO_DWELLER_ITEMS_COUNT = 4
